var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{domProps:{"value":_vm.locale},on:{"change":_vm.change}},[_c('option',{attrs:{"value":"en"}},[_vm._v(_vm._s(_vm.$t('languages.en')))]),_c('option',{attrs:{"value":"es"}},[_vm._v(_vm._s(_vm.$t('languages.es')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }